<template>
  <v-btn @click="createEditVendor" color="primary" target="_blank" elevation="0">
    <v-icon left> mdi-plus </v-icon>
    <span class="d-none d-md-flex body-2">
      {{ $t('vendors.action.create') }}
    </span>
  </v-btn>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'VendorsHeaderActions',

  methods: {
    ...mapActions(['handleOpenCreateEditVendorModal']),

    createEditVendor() {
      this.handleOpenCreateEditVendorModal()

      const createVendor = this.$parent?.$parent?.$refs.rentOutRouterView?.$refs.createVendor
      this.$nextTick(() => createVendor.resetFields())
    },
  },
}
</script>
